import { render, staticRenderFns } from "./TotalOrdersSold.vue?vue&type=template&id=0893e6a3&scoped=true&"
import script from "./TotalOrdersSold.vue?vue&type=script&lang=js&"
export * from "./TotalOrdersSold.vue?vue&type=script&lang=js&"
import style0 from "./TotalOrdersSold.vue?vue&type=style&index=0&id=0893e6a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893e6a3",
  null
  
)

export default component.exports